import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Callout, Typography } from 'seagull';
import { getCumulativeWarning } from '~/components/BillClientModal/BillServiceTableItem/BillServiceTableItem.utils';
import { useLocaleKeys } from '~/i18n';
import { serviceCostModel } from '~/models';
import { utils } from '~/utils';
import pluralize from '~/utils/pluralize';
export default function CumulativeWarningCallout(props) {
    const { service, issueDate, manualServiceBilling, testId, relationshipEffectiveDate } = props;
    const { t: texts } = useLocaleKeys('components.billClientModal');
    const cumulativeWarning = getCumulativeWarning({
        service,
        issueDate,
        manualServiceBilling,
        relationshipEffectiveDate
    });
    function getQuantityText(q) {
        return "".concat(utils.formatNumberWithCommas(q), " ").concat(pluralize(serviceCostModel.formattedUnitName(service.cost), q.toNumber()));
    }
    return cumulativeWarning ? /*#__PURE__*/ _jsx(Callout, {
        style: {
            flex: '1'
        },
        intent: cumulativeWarning.isWarning ? 'warning' : 'info',
        testId: "".concat(testId, "-warning"),
        withBorder: true,
        children: serviceCostModel.isVariablePrice(service.cost) ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                cumulativeWarning.billedQuantity.gt(0) && /*#__PURE__*/ _jsx(Typography, {
                    testId: "".concat(testId, "-billed-quantity"),
                    "data-quantity": cumulativeWarning.billedQuantity,
                    children: texts.billedForQuantity({
                        quantity: getQuantityText(cumulativeWarning.billedQuantity)
                    })
                }),
                cumulativeWarning.scheduledQuantity.gt(0) && /*#__PURE__*/ _jsx(Typography, {
                    testId: "".concat(testId, "-scheduled-quantity"),
                    "data-quantity": cumulativeWarning.scheduledQuantity,
                    children: texts.scheduledForQuantity({
                        quantity: getQuantityText(cumulativeWarning.scheduledQuantity)
                    })
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.clientApprovalRequired()
                })
            ]
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                cumulativeWarning.billedQuantity.gt(0) && /*#__PURE__*/ _jsx(Typography, {
                    testId: "".concat(testId, "-billed-fixed"),
                    children: texts.alreadyBilledForPeriod()
                }),
                cumulativeWarning.scheduledQuantity.gt(0) && /*#__PURE__*/ _jsx(Typography, {
                    testId: "".concat(testId, "-scheduled-fixed"),
                    children: texts.scheduledForPeriod()
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    children: texts.additionalBillRequiresApproval()
                })
            ]
        })
    }) : null;
}
